import ReactGA from "react-ga4";

const GA4_ID = /^G-[A-Z0-9]+$/i;

export const isGoogleAnalyticsMeasurementId = (raw: string): boolean =>
  GA4_ID.test(String(raw || "").trim());

const normalizeId = (raw: string): string => String(raw || "").trim().toUpperCase();

const hkpMeasurementId = (): string =>
  normalizeId(process.env.REACT_APP_GTAG_MEASUREMENT_ID || "");

export type PublicCatalogueAnalyticsPayload = {
  catalogueId: string;
  organizationId?: string;
  linkToken?: string;
  studioMeasurementId?: string;
};

const trackingTargets = (studioMeasurementId?: string): { trackingId: string }[] => {
  const ids: { trackingId: string }[] = [];
  const hkp = hkpMeasurementId();
  const studio = normalizeId(studioMeasurementId || "");
  if (isGoogleAnalyticsMeasurementId(hkp)) {
    ids.push({ trackingId: hkp });
  }
  if (isGoogleAnalyticsMeasurementId(studio) && studio !== hkp) {
    ids.push({ trackingId: studio });
  }
  return ids;
};

/** Dual GA4 on public ?link= pages. Never send phone, email, or name. */
export function trackPublicCatalogueView(payload: PublicCatalogueAnalyticsPayload): void {
  const catalogueId = String(payload.catalogueId || "").trim();
  const linkToken = String(payload.linkToken || "").trim();
  if (!catalogueId || !linkToken) {
    return;
  }
  const targets = trackingTargets(payload.studioMeasurementId);
  if (!targets.length) {
    return;
  }
  ReactGA.initialize(targets);
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
    organization_id: String(payload.organizationId || "").trim() || undefined,
    catalogue_id: catalogueId,
    link_token: linkToken,
  });
}

export function trackCatalogueCreated(catalogueId: string): void {
  const hkp = hkpMeasurementId();
  if (!isGoogleAnalyticsMeasurementId(hkp) || !String(catalogueId || "").trim()) {
    return;
  }
  ReactGA.event("catalogue_created", {
    catalogue_id: String(catalogueId).trim(),
  });
}
